import { createFileRoute, Outlet, useLocation, useNavigate } from '@tanstack/react-router'
import { Suspense } from 'react'
import { Center, Loader } from '@mantine/core'
import { requirePermission } from '@/utils/auth'
import PlanningAreaSelector from '@/components/RoutePlanner/PlanningAreaSelector'

export const Route = createFileRoute('/route-planner')({
  beforeLoad: () => requirePermission('routes', 'write'),
  component: RoutePlannerIndexPage,
})

function RoutePlannerIndexPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const isExact = location.pathname === '/route-planner' || location.pathname === '/route-planner/'

  if (!isExact) {
    return <Outlet />
  }

  return (
    <Suspense
      fallback={
        <Center h="100vh">
          <Loader />
        </Center>
      }
    >
      <PlanningAreaSelector
        onSelectArea={areaId => {
          void navigate({ to: '/route-planner/$areaId', params: { areaId } })
        }}
      />
    </Suspense>
  )
}
